// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js??ref--10-1!../../../node_modules/postcss-loader/lib/index.js??ref--10-2!../../../node_modules/sass-loader/dist/cjs.js??ref--10-3!./home.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("3c64a9de", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/styles/pages/home.scss
// module id = 8/xx
// module chunks = 71